(function () {
  const reviewContainer = document.querySelector('#wc_store_review_page');

  if (!reviewContainer) return;

  // https://documenter.getpostman.com/view/27440833/2s93m343nZ
  /*fetch('https://thimatic-apps.com/rivyo-app/api/get-product-reviews?shop=callisters-christmas.myshopify.com&product_id=10042508690', {
    method: 'GET',
    headers: {
      'Authorization': 'QncvdUNiVUMvc2h4dUFUeitOMDBjdERGNWZ6ZGZiY0xUQVh1bm9GNGkyS0UzVUd6ZC84VFd4b3RKOWhIc203Rw%3D%3D'
    },
    redirect: 'follow'
  }).then(response => response.text())
    .then(result => console.log(result));*/
})();